import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatHorizontalStepper } from '@angular/material';
import * as moment from 'moment';
import { IWebPayItem } from 'src/app/shared/Entities/webPay.entities';
import { WebPayService } from 'src/app/shared/services/web-pay.service';
import {
  IColumnsDataTable,
  IPolizaPagoPendiente,
} from '../../Entities/entities';
import { Event } from '../../enums/insights/event';
import {
  PipeEnum,
  tipoPago,
  tipoPrima,
  FORMA_PAGO,
  key_user_info,
} from '../../helpers/constants';
import { AppInsightsService } from '../../services/app-insights-service';
import { ITokuItem, ITokuPaymentRequest } from '../../Entities/toku.entities';
import { AuthService } from '../../services/auth.service';
import { getLocalStorage } from '@app/shared/helpers/helper';

@Component({
  selector: 'app-webpay',
  templateUrl: './webpay.component.html',
  styleUrls: ['./webpay.component.sass'],
})
export class WebPayComponent implements OnInit {
  propuestas: IPolizaPagoPendiente[] = [];
  itemsCarro: IWebPayItem[] = [];
  itemsCarroToku: ITokuItem[] = [];
  displayedColumns: IColumnsDataTable[] = [];
  formaPago: string = FORMA_PAGO.webpay;
  allowTransactions = false;
  loading = false;
  loadingTokuEnabledRuts = false;
  error = false;
  success = false;
  isTokuEnabled = false;

  @ViewChild('stepper') stepper: MatHorizontalStepper;
  @ViewChild('iframeWebpay') iframeWebpay;
  @ViewChild('formWebPay') formWebPay;

  @Input() dataAPagar: IPolizaPagoPendiente[];
  @Input() isContribution = false;
  @Input() isTokuOptionVisible = false;
  @Output() $closeWebPay = new EventEmitter();

  constructor(
    private webPaySrv: WebPayService,
    private appInsightsService: AppInsightsService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    let i = 0;
    this.dataAPagar.forEach(item => {
      item.index = i;
      i++;
    });
    this.propuestas = this.dataAPagar;
    this.setDisplayColumn();

    if (this.isTokuOptionVisible) {
      this.getTokuEnabledRuts();
    }

    const idCarro = localStorage.getItem('idCarro');
    if (!idCarro) {
      this.allowTransactions = true;
      return;
    }
    this.loading = true;
    this.error = false;
    this.webPaySrv.limpiarCarro(idCarro).subscribe(
      res => {
        this.error = false;
        this.loading = false;
        localStorage.removeItem('idCarro');
        this.allowTransactions = true;
      },
      () => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  getTokuEnabledRuts() {
    const userInfo = getLocalStorage(key_user_info);
    const rut = userInfo.rut.replace('-', '');
    let isTokuEnabledRut = false;
    this.loadingTokuEnabledRuts = true;
    this.webPaySrv.getTokuEnabledRuts().subscribe(
      data => {
        if (data) {
          const param = data[0].Descripcion.trim();
          if (param === 'ALL') {
            isTokuEnabledRut = true;
          } else if (param === 'NONE') {
            isTokuEnabledRut = false;
          } else {
            const enabledRuts = param
              .split(',')
              .map(r => r.replace('-', '').trim());
            isTokuEnabledRut = enabledRuts.includes(rut);
          }

          this.isTokuEnabled = this.isTokuOptionVisible && isTokuEnabledRut;
          this.formaPago = this.isTokuEnabled
            ? FORMA_PAGO.toku
            : FORMA_PAGO.webpay;
        }
        this.loadingTokuEnabledRuts = false;
      },
      err => {
        alert(
          'Ha ocurrido un problema al obtener los ruts habilitados para utilizar Toku.'
        );
        this.loadingTokuEnabledRuts = false;
      },
      () => {}
    );
  }

  onIconClick(item) {
    this.displayedColumns = [];
    const deleteId = item.item.index;
    this.propuestas = this.propuestas.filter(p => {
      const id = p.index;
      return id !== deleteId;
    });

    this.setDisplayColumn();

    // this.displayedColumns = [];
    // const deleteId = `${item.item.Poliza}${item.item.Periodo}`;
    // this.propuestas = this.propuestas.filter(p => {
    //   const id = `${p.Poliza}${p.Periodo}`;
    //   return id !== deleteId;
    // });

    // this.setDisplayColumn();
  }

  mapItemsForWebPay(): IWebPayItem[] {
    return this.propuestas
      .filter(x => x.Checked)
      .map(x => {
        return {
          IdItem: this.propuestas.indexOf(x),
          IdCarro: -1,
          Boleta:
            x.TipoPrima === tipoPrima.esporadica
              ? `300${moment()
                  .format('YYYYMMDDHHmmss')
                  .toString()}`
              : `200${x.NumAviso}`,
          Monto: x.Monto,
          FechaPeriodo: moment(x.Periodo, 'MM-YYYY').format('YYYYMMDD'),
          IdTrxMedioPago: 101,
          Producto: x.NombreProducto,
          NombreProducto: x.NombreProducto,
          TipoProducto: 'POLIZA',
          TipoPrima: x.TipoPrima,
          MedioPago: x.MedioPago,
          CodigoIdentificacion: x.Poliza,
          Canal: 'SPV',
          TipoPago:
            x.TipoPrima === tipoPrima.esporadica
              ? tipoPago.esporadica
              : tipoPago.periodica,
        } as IWebPayItem;
      });
  }

  mapItemsForToku(): ITokuItem[] {
    return this.propuestas
      .filter(x => x.Checked)
      .map(x => {
        return {
          receipt:
            x.TipoPrima === tipoPrima.esporadica
              ? `300${moment()
                  .format('YYYYMMDDHHmmss')
                  .toString()}`
              : `200${x.NumAviso}`,
          amount: x.Monto,
          date: moment(x.Periodo, 'MM-YYYY').format('YYYYMMDD'),
          transactionId: 102,
          product: {
            product: x.NombreProducto.substring(0, 15),
            productName: x.NombreProducto,
            type: 'POLIZA',
          },
          premiumType: x.TipoPrima,
          paymentWay: x.MedioPago,
          transactionCode: x.Poliza,
          paymentType:
            x.TipoPrima === tipoPrima.esporadica
              ? tipoPago.esporadica
              : tipoPago.periodica,
        };
      });
  }

  pagar() {
    this.appInsightsService.trackEvent(Event.iidpBtnPayConfirm);
    this.success = false;
    this.loading = true;

    switch (this.formaPago) {
      case FORMA_PAGO.toku:
        this.itemsCarroToku = this.mapItemsForToku();
        this.setItemCarroToku();
        break;
      case FORMA_PAGO.webpay:
        this.itemsCarro = this.mapItemsForWebPay();
        this.setItemCarroWebpay();
        break;
      case FORMA_PAGO.servipag:
        this.itemsCarro = this.mapItemsForWebPay();
        this.setItemCarroServipag();
        break;
      default:
        break;
    }
  }

  createTokuRedirectPage() : Window {
    const paymentPlatformTab = window.open('', '_blank');
    if (paymentPlatformTab) {
      paymentPlatformTab.document.write(`
        <div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-family: Arial, sans-serif; text-align: center;">
          <div>
            <h1 style="color: #7f00b2;">Redirigiendo a la plataforma de pago</h1>
            <p style="font-size: 1.2rem; color: #555;">
              Por favor, espere un momento para iniciar el proceso de pago.
            </p>
            <div style="display: flex; justify-content: center; margin-top: 20px;">
              <div style="border: 4px solid #f3f3f3; border-top: 4px solid #7f00b2; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite;"></div>
            </div>
          </div>
        </div>
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      `);
    }
    return paymentPlatformTab;
  }
  
  setItemCarroToku() {
    const paymentPlatformTab = this.createTokuRedirectPage();

    this.webPaySrv.enviarPagoToku(this.mapToPaymentToku()).subscribe(
      response => {
        localStorage.setItem('idCarro', response.cartId.toString());
        paymentPlatformTab.location.href = response.urlPago;
        this.success = true;
        this.stepper.next();
        this.loading = false;
      },
      err => {
        this.loading = false;

        if (paymentPlatformTab && !paymentPlatformTab.closed) {
          paymentPlatformTab.close();
        }

        if (
          err.error &
          err.error.userFriendlyError &&
          err.error.userFriendlyError.indexOf('-20200') > -1
        ) {
          alert('Aporte ingresado supera máximo permitido diariamente.');
          return;
        }
        this.success = false;
        alert('Error al crear aporte. Por favor intente más tarde.');
      },
      () => {}
    );
  }
    

  mapToPaymentToku(): ITokuPaymentRequest {
    const paymentType : string = this.itemsCarroToku[0].paymentType;
    return {
      customer: {
        rutDv: this.auth.getRut(),
        fullname: this.auth.getUsername(),
        email: this.auth.getEmail(),
      },
      cartItems: this.itemsCarroToku,
      refIdType: 'PRIVADOCLIENTE',
      policyNumber: this.getPoliza().toString(),
      callBackUrl: {
        url:
          window.location.origin +
          `/comprobanteToku?paymentType=${paymentType}&status=sucess`,
      },
      errorUrl: {
        url:
          window.location.origin +
          `/comprobanteToku?paymentType=${paymentType}&status=error`,
      },
    }
  }

  setItemCarroServipag() {
    this.webPaySrv.agregarItemsCarro(this.itemsCarro).subscribe(response => {
      if (!response) {
        this.loading = false;
        alert('No se ha logrado agregar al carro');
        return;
      }
      localStorage.setItem('idCarro', response.toString());
      this.webPaySrv.enviarPagoServipag(response).subscribe(
        res => {
          this.success = true;
          this.setDateFormServipag(
            'https://www.servipag.com/BotonPago/BotonPago/Pagar',
            res
          );
          this.stepper.next();
          this.loading = false;
        },
        err => {
          this.success = false;
          alert('Ha ocurrido un problema');
          this.loading = false;
        },
        () => {}
      );
    });
  }

  setItemCarroWebpay() {
    this.webPaySrv.agregarItemsCarro(this.itemsCarro).subscribe(response => {
      if (!response) {
        this.loading = false;
        alert('No se ha logrado agregar al carro');
        return;
      }
      if (response.toString().indexOf('-20200') > -1) {
        this.loading = false;
        alert('Aporte ingresado supera máximo permitido diariamente.');
        return;
      }
      localStorage.setItem('idCarro', response.toString());
      this.webPaySrv.enviarPago(response).subscribe(
        res => {
          this.success = true;
          this.stepper.next();
          this.setDateForm(res.Url, res.Token);
          this.loading = false;
        },
        err => {
          this.success = false;
          alert('Ha ocurrido un problema');
          this.loading = false;
        },
        () => {}
      );
    });
  }

  getItemsForPay() {
    return this.propuestas.filter(x => x.Checked);
  }

  setDateForm(url, token) {
    this.formWebPay.nativeElement.token_ws.value = token.toString();
    this.formWebPay.nativeElement.action = url;
    this.formWebPay.nativeElement.submit();
  }

  setDateFormServipag(url, xml) {
    this.formWebPay.nativeElement.xml.value = xml;
    this.formWebPay.nativeElement.action = url;
    this.formWebPay.nativeElement.submit();
  }

  onBackPago() {
    if (this.dataAPagar) {
      this.$closeWebPay.emit(this.propuestas);
    } else {
      this.stepper.previous();
    }
  }

  onCloseWebpay() {
    this.$closeWebPay.emit();
  }

  getPoliza() {
    const itemsForPay = this.getItemsForPay();
    return itemsForPay.length > 0 ? itemsForPay[0].Poliza : -1;
  }

  getTotalAmount() {
    return this.getItemsForPay().reduce((sum, item) => sum + item.Monto, 0);
  }

  setDisplayColumn() {
    this.displayedColumns = [
      {
        ColumnDef: 'Poliza',
        ColumnName: 'Nº PÓLIZA',
        Sum: 'TOTAL',
      },
      {
        ColumnDef: 'NombreProducto',
        ColumnName: '	PRODUCTO',
        Sum: '',
      },
      {
        ColumnDef: 'TipoPrima',
        ColumnName: '	Tipo de Prima',
        Sum: '',
      },
      {
        ColumnDef: 'Periodo',
        ColumnName: 'PERIODO',
        Sum: '',
      },
      {
        ColumnDef: 'Monto',
        ColumnName: 'MONTO ($)',
        Pipe: PipeEnum.decimalPipe,
        Sum: this.getTotalAmount(),
        // getArraySumByField(this.propuestas, 'Monto')
      },
      {
        ColumnDef: 'cancel.svg',
        ColumnName: 'Eliminar',
        SvgIcon: true,
        Icon: true,
      },
    ] as IColumnsDataTable[];
  }
}
